import awaitPeerDependencies from '@ssr/registry';
import { loadEnv } from './load-env';
import canonify from '../../server/src/canonify';

const variableName = canonify('promo-topbanner');

const peerDependencies = [
  'react',
  'react-dom',
  'react-intl',
  'styled-components',
];

loadEnv(variableName);

const index = translations => {
  return awaitPeerDependencies(peerDependencies).then(
    ({ react: React, 'react-dom': ReactDom }) => {
      import(/* webpackChunkName: "app" */ '../../app')
        .then(({ default: App }) => {
          const { __environment__, ...state } = window[variableName] || {};

          ReactDom.hydrate(
            <App state={state} translations={translations} />, // eslint-disable-line
            document.getElementById('fragment-promo-topbanner'),
          );
        })
        .catch(e => {
          console.log(e); // eslint-disable-line no-console
        });
    },
  );
};

export { index };
